<template>
    <div class="time-sheet">
        <!-- <myBreadCrumb :urls="JSON.stringify(breadcrumbs)"></myBreadCrumb> -->
        <!-- <v-card class="mb-6">
        </v-card> -->
        <v-card class="rounded-lg" flat>
            <!-- <v-card-title> 
                <span class="d-none d-md-inline ">Danh sách giờ công</span><v-spacer></v-spacer>
                <refresh-button @click="fetchData"></refresh-button>
                <v-btn icon @click="mTimesheetDialog=!mTimesheetDialog"><v-icon>mdi-calendar-check-outline</v-icon></v-btn>
                <data-filter v-model="params" :filter="filter" @fetchData="fetchData(true)">
                </data-filter>
                <v-btn small color="grey lighten-5" :to="{name: 'TimeSheet2'}" class="mx-1"><v-icon>mdi-view-list</v-icon></v-btn>
            </v-card-title> -->
            <v-dialog v-model="mTimesheetDialog" max-width="600">
                <v-card>
                    <v-card-title>Bảng công tháng</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <month-picker mTimesheet.month label="ssss"></month-picker>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <!-- <excel-button @click="exportPrompt=true"></excel-button> -->
            <export-prompt v-model="exportPrompt" url="Timesheets" fileName="BANG_CHAM_CONG">
            </export-prompt>

            <v-card-title class="d-flex flex-wrap align-center justify-space-between pt-4 pb-2 px-4 px-md-6">
                <span class="text-h6 font-weight-bold">Danh sách giờ công</span>

                <v-spacer class="d-none d-sm-block"></v-spacer>

                <div class="d-flex align-center wrapper mx-1 my-1">
                    <v-btn @click="fetchData" outlined color="green lighten-3" class="rounded-lg"
                        style="width: 40px !important; height: 40px; padding: 0px;">
                        <v-icon color="green darken-4">mdi-refresh</v-icon></v-btn>
                </div>

                <v-divider vertical class="mx-4"></v-divider>

                <!-- <data-export v-model="exportDialog"></data-export> -->
                <v-btn @click="exportPrompt = true" outlined color="success"
                    class="rounded-lg font-weight-bold px-6"
                    style="text-transform: none; letter-spacing: 0.5px; height: 40px;">
                    <v-icon left>mdi-file-excel</v-icon> Xuất Excel
                </v-btn>
            </v-card-title>
            <v-sheet class="grey lighten-4 py-6">
                <div class="d-flex flex-wrap mx-n2 px-4">
                    <v-text-field v-model="month" type="date" label="Tháng" outlined dense hide-details
                        persistent-placeholder background-color="white" style="max-width: 180px;"
                        class="mx-2 my-2 flex-shrink-1"></v-text-field>

                    <v-select :items="[
                        { text: 'Mã NS', value: 'EmployeeCode' },
                        { text: 'Tên NS', value: 'EmployeeName' },
                    ]" v-model="params.searchAttrs[0]" outlined dense label="Tìm theo" hide-details
                        persistent-placeholder background-color="white" style="max-width: 150px;"
                        class="mx-2 my-2 flex-shrink-1">
                    </v-select>

                    <v-text-field label="Từ khóa tìm kiếm" v-model="params.searchs[0]" dense hide-details outlined
                        background-color="white" persistent-placeholder placeholder="Nhập từ khóa..."
                        style="min-width: 250px; max-width: 250px;" class="mx-2 my-2 flex-grow-1 flex-shrink-0">
                    </v-text-field>

                    <v-autocomplete :items="filter.FilterAttrs[0].items" item-text="name" item-value="code"
                        label="Phòng ban (Chi nhánh)" v-model="params.searchs[1]" clearable
                        @change="nullFix($event, 1), getTeam()" dense hide-details outlined background-color="white"
                        persistent-placeholder placeholder="Chọn phòng ban" style="min-width: 250px; flex: 1 1 auto;"
                        class="mx-2 my-2">
                    </v-autocomplete>

                    <v-autocomplete :items="filter.FilterAttrs[2].items" item-text="name" item-value="code"
                        label="Bộ phận (Team)" v-model="params.searchs[2]" clearable @change="nullFix($event, 2)"
                        outlined dense hide-details background-color="white" persistent-placeholder
                        placeholder="Chọn bộ phận" style="min-width: 250px; flex: 1 1 auto;" class="mx-2 my-2">
                    </v-autocomplete>

                    <v-btn color="teal darken-1" dark @click="fetchData(true)" class="rounded-lg mx-2 my-2 elevation-1"
                        height="40" style="min-width: 120px; font-weight: bold; text-transform: none; letter-spacing: 0.5px;">
                        <v-icon left>mdi-magnify</v-icon> Tìm kiếm
                    </v-btn>
                </div>
            </v-sheet>

            <!-- Chú thích / Legend -->
            <v-divider></v-divider>
            <div class="d-flex align-center flex-wrap px-6 py-2" style="font-size: 13px; background-color: #fdfdfd;">
                <span class="font-weight-bold mr-4 text-uppercase grey--text text--darken-2"
                    style="font-size: 12px;"><v-icon small left class="mr-1">mdi-help-box</v-icon> Chú thích ý nghĩa các
                    cột:</span>

                <v-chip outlined small color="green darken-2" class="mr-3 font-weight-medium">
                    <v-icon x-small left>mdi-briefcase-outline</v-icon> Giờ làm việc
                </v-chip>

                <v-chip outlined small color="cyan darken-2" class="mr-3 font-weight-medium">
                    <v-icon x-small left>mdi-av-timer</v-icon> Giờ tăng ca
                </v-chip>

                <v-chip outlined small color="pink darken-1" class="mr-3 font-weight-medium">
                    <v-icon x-small left>mdi-umbrella-beach</v-icon> Giờ nghỉ phép
                </v-chip>

                <v-chip outlined small color="red darken-2" class="font-weight-bold">
                    chưa XN (Chưa xác nhận)
                </v-chip>
            </div>
            <v-divider></v-divider>
            <div class="datatable-scroll-container">
                <!-- Left Scroll Button -->
                <v-btn
                    v-if="canScrollLeft"
                    fab
                    dark
                    small
                    color="teal darken-4"
                    class="scroll-edge-btn left-btn"
                    @click="scrollTable('left')"
                    title="Cuộn sang trái"
                >
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>

                <v-data-table fixed-header height="calc(100vh - 325px)" :mobile-breakpoint="0" :headers="combinedHeaders"
                    :items="mappedTableData" :options.sync="options" :server-items-length="totalItem"
                    :footer-props="{ 'items-per-page-options': [15, 30, 50, 100] }">
                    <template v-slot:[`item.name`]="{ item }">
                        {{ item.name }}
                        <h5 :class="`font-weight-bold ${item.sum < item.totalHour ? 'error--text' : 'sucess--text'} `">
                            {{ item.sum }}/{{ item.totalHour }}</h5>
                    </template>
                    <template v-for="combinedHeader in combinedHeaders.slice(4)"
                        v-slot:[`item.${combinedHeader.value}`]="{ item }">
                        <div :key="combinedHeader.value"
                            @click="openDetail(item[combinedHeader.value] ? item[combinedHeader.value].code : null, combinedHeader.value, item.code)"
                            class="pa-1">
                            <v-hover v-slot="{ hover }">
                                <v-sheet
                                    :class="`mx-auto my-auto rounded d-flex flex-column px-1 py-1 elevation-${hover ? 3 : 0} transition-swing`"
                                    style="cursor:pointer;" v-if="item[combinedHeader.value]"
                                    :color="item[combinedHeader.value].isLock ? 'grey lighten-4' : item[combinedHeader.value].isUnder ? 'red lighten-5' : 'blue lighten-5'"
                                    width="118px" height="85px">

                                    <div class="font-weight-medium d-flex align-center justify-space-around mt-1"
                                        style="font-size: 11px !important; letter-spacing: -0.4px; width: 100%;">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on"
                                                    class="green--text text--darken-2 d-flex align-center">
                                                    <v-icon x-small color="green darken-2"
                                                        style="font-size: 12px; margin-right: 1px;">mdi-briefcase-outline</v-icon>{{
                                                            item[combinedHeader.value].totalSalaryTime }}h
                                                </span>
                                            </template>
                                            <span>Giờ làm việc</span>
                                        </v-tooltip>
                                        <span class="grey--text" style="font-size: 9px;">|</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on"
                                                    class="cyan--text text--darken-2 d-flex align-center">
                                                    <v-icon x-small color="cyan darken-2"
                                                        style="font-size: 12px; margin-right: 1px;">mdi-av-timer</v-icon>{{
                                                            item[combinedHeader.value].totalOverTime }}h
                                                </span>
                                            </template>
                                            <span>Giờ tăng ca</span>
                                        </v-tooltip>
                                        <span class="grey--text" style="font-size: 9px;">|</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on"
                                                    class="pink--text text--darken-1 d-flex align-center">
                                                    <v-icon x-small color="pink darken-1"
                                                        style="font-size: 12px; margin-right: 1px;">mdi-umbrella-beach</v-icon>{{
                                                            item[combinedHeader.value].totalLeaveTime }}h
                                                </span>
                                            </template>
                                            <span>Giờ nghỉ phép</span>
                                        </v-tooltip>
                                    </div>

                                    <v-spacer></v-spacer>

                                    <div class="orange--text text--darken-3 font-weight-bold text-center"
                                        style="font-size: 14px; line-height: 1.2;">
                                        {{ item[combinedHeader.value].symbol }}
                                    </div>

                                    <v-spacer></v-spacer>

                                    <div class="text-center" style="min-height: 16px;">
                                        <small class="text-caption red--text text--darken-2 font-weight-bold"
                                            v-if="!item[combinedHeader.value].isConfirmed">chưa XN</small>
                                    </div>
                                </v-sheet>

                                <v-sheet
                                    :class="`mx-auto rounded my-auto text-center elevation-${hover ? 2 : 0} d-flex align-center justify-center transition-swing`"
                                    style="cursor:pointer;" width="118px" height="85px" v-else color="transparent">
                                    <v-icon color="grey lighten-1">mdi-plus</v-icon>
                                </v-sheet>
                            </v-hover>
                        </div>
                    </template>

                    <template v-for="combinedHeader in combinedHeaders.slice(2)"
                        v-slot:[`header.${combinedHeader.value}`]="{ header }">
                        <span :key="combinedHeader.value" :class="header.text?.includes('CN') ? 'red--text' : ''">{{
                            header.text }}</span>
                    </template>
                </v-data-table>

                <!-- Right Scroll Button -->
                <v-btn
                    v-if="canScrollRight"
                    fab
                    dark
                    small
                    color="teal darken-4"
                    class="scroll-edge-btn right-btn"
                    @click="scrollTable('right')"
                    title="Cuộn sang phải"
                >
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </div>

            <!-- ************** TIMESHEET DETAIL *************** -->
            <v-dialog v-model="detailDialog" scrollable width="800px" @click:outside="closeDetail">
                <v-card>
                    <v-card-title class="text-subtitle-1">Chi tiết giờ công <v-spacer></v-spacer> <v-icon
                            @click="openDetail">mdi-reload</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <v-tabs hide-slider color="green darken-2" active-class="border-active">
                            <v-tab>
                                Xác nhận công
                            </v-tab>
                            <v-tab>
                                Chấm công
                            </v-tab>
                            <v-tab v-if="isAdmin">
                                CnB xác nhận
                            </v-tab>

                            <v-tab-item>
                                <v-form>
                                    <v-row class="mt-0">
                                        <!-- <v-col cols="12">
                                            <v-subheader :class="(detailItem.isConfirmed?'success': 'error')+'--text'" ><h3>{{detailItem.isConfirmed ? 'Xác nhận' : 'Chưa xác nhận'}}</h3></v-subheader>
                                            <v-switch v-model="detailItem.isConfirmed" label="Xác nhận" hide-details></v-switch>
                                        </v-col> -->
                                        <v-col cols="6">
                                            <v-text-field label="Tổng giờ đã làm" type="number"
                                                v-model="detailItem.actualWorkTime" min="0" :disabled="false"
                                                hide-details outlined>
                                                <template v-slot:[`append`]="">
                                                    <v-icon color="blue">mdi-clock</v-icon>
                                                </template>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-btn small color="primary" class="my-3 mx-2" @click="acceptTimesheet">Xác
                                                nhận</v-btn>
                                            <v-btn small outlined color="error" class="my-3 mx-2"
                                                @click="cancelTimesheet">Hủy xác
                                                nhận</v-btn>
                                        </v-col>

                                        <v-col cols="12"><v-divider></v-divider></v-col>
                                        <v-col cols="12" class="text--primary">
                                            <small class="error--text">Các trường mang dấu * không thể thay đổi</small>
                                            <v-row>
                                                <v-col cols="4" class="font-weight-bold text-primary">Danh mục</v-col>
                                                <v-col cols="4" class="font-weight-bold text-primary">Số giờ</v-col>
                                                <v-col cols="4" class="font-weight-bold text-primary">Số Cơm</v-col>

                                                <v-col cols="4"
                                                    class="font-weight-medium green--text text--darken-4">Giờ xác nhận
                                                    làm việc</v-col>
                                                <v-col cols="4" class="font-weight-medium">{{ detailItem.validActualTime
                                                    }}</v-col>
                                                <v-col cols="4" class="font-weight-medium">{{ detailItem.lunch
                                                    }}</v-col>

                                                <v-col cols="4"
                                                    class="font-weight-medium orange--text text--darken-4">Giờ tăng
                                                    ca</v-col>
                                                <v-col cols="4" class="font-weight-medium">{{ detailItem.overtime
                                                    }}</v-col>
                                                <v-col cols="4" class="font-weight-medium">{{ detailItem.overtimeLunch
                                                    }}</v-col>

                                                <v-col cols="4" class="font-weight-medium red--text text--darken-4">Giờ
                                                    nghỉ
                                                    phép</v-col>
                                                <v-col cols="8" class="font-weight-medium">{{ detailItem.leaveTime
                                                    }}</v-col>
                                                <!-- <v-col cols="4" class="font-weight-medium">{{detailItem.overtimeLunch}}</v-col> -->
                                            </v-row>
                                        </v-col>
                                        <!-- <v-col cols="12">
                                            <v-text-field label="Nghỉ phép *" type="number" readonly v-model="detailItem.leaveTime" min=0 color="error">
                                                <template v-slot:[`append`]="">
                                                    <v-icon color="pink">mdi-umbrella-beach</v-icon>
                                                </template>
                                            </v-text-field>
                                        </v-col> -->
                                        <!-- <v-col cols="6">
                                            <v-text-field label="Giờ làm việc *" type="number" readonly v-model="detailItem.validActualTime" min=0 color="error" hide-details outlined dense>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field label="Cơm *" type="number" readonly v-model="detailItem.lunch" min=0 color="error" hide-details outlined dense>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field label="Tăng ca *" type="number" readonly v-model="detailItem.overtime" min=0 color="error" hide-details outlined dense>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field label="Cơm tăng ca *" type="number" readonly v-model="detailItem.overtimeLunch" min=0 color="error" hide-details outlined dense>
                                            </v-text-field>
                                        </v-col> -->
                                        <v-col cols="12">
                                            <v-divider></v-divider>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-subheader class="font-weight-bold pl-0 text-primary">
                                                Đơn phiếu yêu cầu
                                            </v-subheader>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-row>
                                                <v-col cols="4"
                                                    class="font-weight-medium green--text text--darken-4">Duyệt
                                                    công</v-col>
                                                <v-col cols="8">
                                                    <v-btn x-small color="error" v-if="detailItem.confirmRequestId"
                                                        target="_blank"
                                                        :href="`/admin/employment/Confirm/confirm-timesheet?refId=${detailItem.confirmRequestId}`">
                                                        Phiếu {{ detailItem.confirmRequestId }}
                                                    </v-btn>
                                                    <span v-else>Không có phiếu</span>
                                                </v-col>

                                                <v-col cols="4"
                                                    class="font-weight-medium orange--text text--darken-4">Tăng
                                                    ca</v-col>
                                                <v-col cols="8">
                                                    <v-btn color="orange" @click="overtimeOpen" v-if="!!overtimeCode"
                                                        x-small>
                                                        <v-icon>mdi-av-timer</v-icon>
                                                        Phiếu làm thêm
                                                    </v-btn>
                                                    <v-btn color="orange" dark @click="overtimeOpen" x-small v-else>
                                                        <v-icon left>mdi-plus</v-icon>
                                                        Phiếu làm thêm
                                                    </v-btn>
                                                </v-col>

                                                <v-col cols="4"
                                                    class="font-weight-medium red--text text--darken-4">Phiếu
                                                    OFF</v-col>
                                                <v-col cols="8">
                                                    <v-chip small label dark color="secondary" class="ml-2"
                                                        v-if="!detailItem.leaveRequest">
                                                        Không có phiếu
                                                    </v-chip>
                                                    <v-chip small label dark color="red darken-2" class="ml-2" v-else>
                                                        Mã phiếu: {{ detailItem.leaveRequest.code }}
                                                    </v-chip>
                                                </v-col>

                                                <v-col cols="4"
                                                    class="font-weight-medium blue--text text--darken-4">Phiếu công
                                                    tác</v-col>
                                                <v-col cols="8">
                                                    <v-chip small label dark color="secondary" class="ml-2"
                                                        v-if="!detailItem.businessRequest">
                                                        Không có phiếu
                                                    </v-chip>
                                                    <v-chip small label dark color="blue" class="ml-2" v-else>
                                                        Phiếu công tác: {{ detailItem.businessRequest.code }}
                                                    </v-chip>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12">
                                        </v-col>
                                        <!-- <v-subheader style="width: 100%;">Phiếu tăng ca:</v-subheader> -->
                                        <v-col cols="12" class="py-0">
                                        </v-col>
                                        <v-col cols="12">
                                            <v-textarea label="Ghi chú" persistent-placeholder v-model="detailItem.note"
                                                outlined></v-textarea>
                                        </v-col>
                                        <v-subheader class="font-weight-bold" v-if="detailItem.isConfirmed"
                                            style="width: 100%;">
                                            Lần cuối xác nhận
                                        </v-subheader>
                                        <v-col cols="6" v-if="detailItem.isConfirmed">
                                            <v-text-field label="Người xác nhận" type="text" readonly
                                                v-model="detailItem.acceptedBy" min=0 color="error">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="6" v-if="detailItem.isConfirmed">
                                            <v-text-field label="Thời gian xác nhận" type="text" readonly
                                                v-model="detailItem.acceptedAt" min=0 color="error">
                                            </v-text-field>
                                        </v-col>
                                        <div class="d-block" style="width: 100%;">
                                            <v-divider></v-divider>
                                        </div>
                                        <v-subheader class="font-weight-bold">
                                            Lịch sử xác nhận <span class="green--text ml-1">mới</span>
                                        </v-subheader>
                                        <v-col cols="12">
                                            <v-simple-table dense>
                                                <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left">
                                                                Hành động
                                                            </th>
                                                            <th class="text-left">
                                                                Người thao tác
                                                            </th>
                                                            <th class="text-left">
                                                                Ngày thao tác
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, key) in confirmHistory" :key="key">
                                                            <td>{{ item.action == 'CONFIRM' ? 'Xác nhận' : 'Bỏ xác nhận'
                                                            }}</td>
                                                            <td>{{ item.updatedBy }}</td>
                                                            <td>{{ formatDateTime(item.updatedAt) }}</td>
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-tab-item>
                            <v-tab-item>
                                <v-sheet class="px-0">
                                    <!-- ENROLLMENT -->
                                    <!-- <v-subheader class="pl-0">Chấm công:</v-subheader> -->
                                    <v-data-table :items="detailItem.enrollments" dense :headers='[
                                        { text: "Giờ checkin", value: "checkinTime" },
                                        { text: "Giờ checkout", value: "checkoutTime" },
                                        { text: "IP checkin", value: "ipIn" },
                                        { text: "IP checkout", value: "ipOut" },
                                        { text: "Trễ", value: "late" },
                                        { text: "Sớm", value: "early" }
                                    ]' height="300px">
                                        <!-- <template v-slot:[`footer.prepend`]>
                                            Số giờ ghi nhận: <span class="ml-2 font-weight-bold">{{Math.round(detailItem.workTime * 100) / 100}}</span>
                                        </template> -->
                                    </v-data-table>
                                </v-sheet>
                            </v-tab-item>
                            <v-tab-item v-if="isAdmin">
                                <!-- ADMIN section -->
                                <v-subheader style="width: 100%;" v-if="isAdmin">
                                    <b class="text--primary">ADMIN XÁC NHẬN</b>
                                </v-subheader>
                                <v-col v-if="isAdmin">
                                    <v-text-field outlined v-model="admin.validActualTime" label="Giờ công làm việc"
                                        hint="Sau khi admin xác nhận dữ liệu sẽ bị khóa, các cấp dưới admin sẽ không có quyền thay đổi">
                                    </v-text-field>
                                    <v-text-field outlined v-model="admin.validOvertime"
                                        label="Giờ công làm thêm khả dụng"
                                        hint="Sau khi admin xác nhận dữ liệu sẽ bị khóa, các cấp dưới admin sẽ không có quyền thay đổi">
                                    </v-text-field>
                                    <v-btn color="primary" class="mx-2" @click="adminConfirmTimesheet">Áp dụng</v-btn>

                                    <v-btn color="error" class="mx-2" @click="overtimeConfirmTimesheet">Chỉnh giờ tăng
                                        ca</v-btn>
                                </v-col>
                                <v-col cols="12" v-if="isAdmin">
                                    <small class="red--text">
                                        <b>Chỉnh giờ tăng ca:</b> Chỉnh giờ tăng ca sẽ điều chỉnh giờ phiếu làm thêm, và
                                        cập nhật
                                        giờ tăng ca ở bảng giờ công
                                    </small>
                                </v-col>
                            </v-tab-item>
                        </v-tabs>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeDetail">Thoát</v-btn>
                        <v-btn text @click="saveData" class="mr-2">OK</v-btn>

                        <v-dialog max-width="600">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="error" v-bind="attrs" v-on="on">
                                    Xóa
                                </v-btn>
                            </template>
                            <template v-slot:default="dialog">
                                <v-card>
                                    <v-toolbar color="primary" dark flat>
                                        Xóa giờ công
                                    </v-toolbar>
                                    <v-card-actions class="justify-end">
                                        <v-spacer></v-spacer>
                                        <v-btn text @click="deleteItem(), dialog.value = false">Xóa công</v-btn>
                                        <v-btn text @click="dialog.value = false">Hủy</v-btn>
                                        <v-spacer></v-spacer>
                                    </v-card-actions>
                                </v-card>
                            </template>
                        </v-dialog>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <create-dialog v-model="overtimeDialog" @CloseDialog="overtimeClose" @fetchData="fetchData"></create-dialog>
        </v-card>
    </div>
</template>

<script>

import myBreadCrumb from '@/components/BreadCrumb';
import moment from 'moment/moment';
import http from '@/components/services/http-common';
import DatePicker from '@/components/DatePicker';
import DataFilter from '@/components/DataFilter';
import EventBus from "@/components/services/EventBus";
import Create from '@/views/Request/Overtime/Create';
// import * as moment from "moment/moment"

export default {
    name: "TimeSheet",
    components: {
        myBreadCrumb,
        "create-dialog": Create,
        "date-picker": DatePicker,
        "data-filter": DataFilter
    },
    computed: {
        isAdmin() {
            var claimString = localStorage.getItem("userClaim")
            if (claimString) {
                if (claimString.includes("timesheet:advconfirm"))
                    return true
            }
            return false
        },

        combinedHeaders() {
            let dateHeaders = [];

            let from = moment(this.params.from, "YYYY-MM-DD");
            let to = moment(this.params.to, "YYYY-MM-DD");
            while (from.isSameOrBefore(to)) {
                var d = from.day();
                d = d == 0 ? "CN" : "Thứ " + String(d + 1);
                var dd = from.format('DD');
                var mm = from.format('MM');
                var yyyy = from.format('YYYY');

                dateHeaders.push({
                    text: `Ngày ${dd} (${d})`,
                    value: `${dd}${mm}${yyyy}`,
                    align: "center",
                    sortable: false,
                    cellClass: 'small-cell',
                    divider: true
                });
                from.add(1, 'day');
            }
            const reversedDates = dateHeaders.reverse();
            return this.fixedHeaders.concat(reversedDates);
        },
        mappedTableData() {
            var result = this.tableData.map(e => {
                let Obj = {};
                Obj.name = e.name;
                Obj.code = e.code;
                Obj.departmentName = e.departmentName;
                Obj.divisionName = e.divisionName;
                Obj.sum = e.sum;
                Obj.totalHour = e.totalHour;
                e.timesheets.forEach(i => {
                    Obj[i.workDateStr] = {
                        isLock: i.isLock,
                        isUnder: i.isUnder,
                        code: i.code,
                        symbol: i.symbol,
                        isConfirmed: i.isConfirmed,
                        totalTime: i.totalTime,
                        totalSalaryTime: i.totalSalaryTime,
                        totalHolidaySalaryTime: i.totalHolidaySalaryTime,
                        totalExtendedTime: i.totalExtendedTime,
                        totalLeaveTime: i.totalLeaveTime,
                        totalOverTime: i.totalOverTime,
                        totalHolidayOverTime: i.totalHolidayOverTime,
                        validActualTime: i.validActualTime,
                    };
                });
                return Obj;
            })
            return result;
        },
    },
    watch: {
        options: {
            handler(val) {
                this.fetchData();
            },
            deep: true,

        },
        detailDialog(val) {
            if (val) {
                return val;
            }
            else
                this.closeDetail();
        },
        month(val) {
            if (moment(val, "YYYY-MM-DD", true).isValid()) {
                this.params.from = moment(val).subtract(1, 'month').date(26).format('YYYY-MM-DD')
                this.params.to = moment(val).date(25).format('YYYY-MM-DD')
            }
        }
    },
    data() {
        // Tính toán tháng công mặc định (bắt đầu từ ngày 26 tháng trước đến ngày 25 tháng này)
        const currentDate = moment();
        const defaultMonthVal = currentDate.date() > 25 
            ? currentDate.clone().add(1, 'month') 
            : currentDate.clone();
        const defaultMonthStr = defaultMonthVal.startOf('months').format("YYYY-MM-DD");
        const defaultFrom = defaultMonthVal.clone().subtract(1, 'month').date(26).format("YYYY-MM-DD");
        const defaultTo = defaultMonthVal.clone().date(25).format("YYYY-MM-DD");

        return {
            TIMESHEET_URL: "timesheets",
            exportPrompt: false,
            mTimesheetDialog: false,
            canScrollLeft: false,
            canScrollRight: false,
            //FILTER
            month: defaultMonthStr,
            params: {
                sortBy: [],
                sortDesc: [],
                page: "",
                itemsPerPage: "",
                searchs: ["", ""],
                searchAttrs: ['EmployeeCode', 'DepartmentCode', 'TeamCode'],
                underOnly: false,

                fromOn: "",
                from: defaultFrom,
                to: defaultTo,
            },

            filter: {
                menu: false,
                search: "",
                searchAttr: "EmployeeName",
                department: "",
                underOnly: false,

                from: defaultFrom,
                to: defaultTo,
                fromOns: [
                    { text: "Ngày làm việc", value: "workDate" }
                ],
                fromOn: "workDate",

                searchAttrs: [
                    { text: "Tên nhân viên", value: "EmployeeName" },
                    { text: "MSNV", value: "employeeCode" },
                ],
                FilterAttrs: [
                    { text: "Phòng", items: [] },
                    { text: "Chức danh", items: [] },
                    { text: "Team", items: [] }
                ],
                FilterOn: ["DepartmentCode"],

            },

            //DETAIL ITEM
            admin: {
                validActualTime: 0,
                validOvertime: 0
            },

            detailItem: {
                employeeCode: null,
                code: "",
                shiftHour: 0,
                actualWorkTime: 0,
                holidayActualTime: 0,
                overtime: 0,
                holidayOvertime: 0,
                leaveTime: 0,
                isConfirmed: false,
                lunch: 0,
                overtimeLunch: 0,
                late: 0,
                early: 0,
                enrollments: [],
                workDateStr: "",
                validActualTime: 0,
                validOvertime: 0,
                note: "",
                acceptedBy: "",
                acceptedAt: "",
                confirmRequestId: null,
                leaveRequest: null,
                businessRequest: null
            },
            defaultDetailItem: {
                employeeCode: null,
                code: "",
                actualWorkTime: 0,
                holidayActualTime: 0,
                overtime: 0,
                holidayOvertime: 0,
                leaveTime: 0,
                isConfirmed: false,
                lunch: 0,
                overtimeLunch: 0,
                late: 0,
                early: 0,
                enrollments: [],
                workDateStr: "",
                validActualTime: 0,
                validOvertime: 0,
                note: "",
                acceptedBy: "",
                acceptedAt: "",
                confirmRequestId: null,
                leaveRequest: null,
                businessRequest: null
            },
            detailDialog: false,
            overtimeCode: "",
            overtimeDialog: {
                state: false,
                timesheet: true,
                item: {
                    adminEmployeeCode: ""
                }
            },
            confirmHistory: [],

            // DATATABLE
            options: {},
            totalItem: 0,
            filters: {
                FromDate: moment().startOf("month").format("YYYY-MM-DD"),
                ToDate: moment().endOf("month").format("YYYY-MM-DD"),
                DepartmentCode: "",
            },
            Departments: [],
            breadcrumbs: [
                {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                    }
                },
                {
                    text: 'Danh sách giờ công',
                    disabled: true
                },
            ],

            headers: [],
            fixedHeaders: [
                { text: 'Mã nhân viên', align: 'center', value: 'code', width: "100px", sortable: false },
                { text: 'Tên nhân viên', align: 'center', sortable: false, value: 'name', width: "120px", divider: true, },
                { text: 'Phòng (chi nhánh)', align: 'center', sortable: false, value: 'departmentName', width: "150px", divider: true, class: 'd-none d-sm-table-cell', cellClass: 'd-none d-sm-table-cell' },
                { text: 'Bộ phận', align: 'center', sortable: false, value: 'divisionName', width: "150px", divider: true, class: 'd-none d-sm-table-cell', cellClass: 'd-none d-sm-table-cell' },
            ],

            tableData: [],

        }
    },
    methods: {

        adminConfirmTimesheet() {
            return http.post('timesheets/admin-confirm-timesheet', {
                employeeCode: this.detailItem.employeeCode,
                workDate: this.detailItem.workDate,
                validActualTime: this.admin.validActualTime,
                validOvertime: this.admin.validOvertime
            }).then(d => {
                console.log(d)
                this.fetchData();
            })
        },

        overtimeConfirmTimesheet() {
            return http.post('timesheets/overtime-confirm-timesheet', {
                employeeCode: this.detailItem.employeeCode,
                workDate: this.detailItem.workDate,
                validActualTime: this.admin.validActualTime,
                validOvertime: this.admin.validOvertime
            }).then(d => {
                console.log(d)
                this.fetchData();
            })
        },
        nullFix(value, searchIndex = 1) {
            console.log(value, searchIndex)
            if (value == null)
                this.params.searchs[searchIndex] = ''
        },
        getConfirmHistory(itemCode) {
            return http.get('timesheets/confirm-history/' + itemCode).then(r => {
                return r.data
            })
        },
        updateTimesheetExport() {
        },
        overtimeOpen() {
            this.overtimeDialog.state = true;
            if (this.detailItem) {
                this.overtimeDialog.timesheet = true;
                this.overtimeDialog.item.adminEmployeeCode = this.detailItem.employeeCode;
                this.overtimeDialog.item.date = moment(this.detailItem.workDate, "YYYY-MM-DD").format("YYYY-MM-DD");
                if (!!this.overtimeCode) {
                    this.overtimeDialog.item.code = this.overtimeCode
                }
            }
        },
        overtimeClose() {
            this.overtimeDialog.state = false;

        },
        formatTime(value) {
            return moment(value).format("HH:mm:ss");
        },
        formatDateTime(value) {
            return moment(value).format("DD/MM/YY HH:mm:ss");
        },
        initDateRange() {
            // Thiết lập khoảng ngày theo tháng công mặc định (từ ngày 26 tháng trước đến ngày 25 tháng được chọn)
            const currentDate = moment();
            const defaultMonthVal = currentDate.date() > 25 
                ? currentDate.clone().add(1, 'month') 
                : currentDate.clone();
            const first = defaultMonthVal.clone().subtract(1, 'month').date(26).format("YYYY-MM-DD");
            const last = defaultMonthVal.clone().date(25).format("YYYY-MM-DD");
            
            this.filter.from = first;
            this.filter.to = last;
            this.params.from = first;
            this.params.to = last;
        },
        scrollTable(direction) {
            const container = this.$el.querySelector('.v-data-table__wrapper');
            if (container) {
                const scrollAmount = container.clientWidth * 0.6;
                const targetScroll = container.scrollLeft + (direction === 'left' ? -scrollAmount : scrollAmount);
                container.scrollTo({
                    left: targetScroll,
                    behavior: 'smooth'
                });
            }
        },
        updateScrollState() {
            const container = this.$el.querySelector('.v-data-table__wrapper');
            if (container) {
                this.canScrollLeft = container.scrollLeft > 5;
                this.canScrollRight = container.scrollLeft < (container.scrollWidth - container.clientWidth - 5);
            }
        },

        messageToast(eventObj) {
            EventBus.$emit('hasMessage', eventObj);
        },
        // DETAIL DIALOG
        openDetail(itemCode, dateCode, employeeCode) {
            this.detailItem.workDateStr = dateCode;
            this.detailItem.employeeCode = employeeCode;

            if (itemCode) {
                http.get(this.TIMESHEET_URL + "/" + itemCode)
                    .then((res) => {
                        let data = res.data;
                        this.detailItem = Object.assign({}, data.item);
                        this.detailItem.enrollments = data.enrollments;
                        this.detailItem.workDateStr = dateCode;
                        this.overtimeCode = res.data.phieu_lam_them_str;
                        this.detailItem.confirmRequestId = res.data.confirmRequestId
                        this.detailItem.leaveRequest = res.data.leaveRequest
                        this.detailItem.businessRequest = res.data.businessRequest

                        //admin
                        this.admin.validActualTime = this.detailItem.validActualTime
                        this.admin.validOvertime = this.detailItem.validOvertime

                        this.getConfirmHistory(itemCode).then(d => {
                            this.confirmHistory = d.data
                        })

                        this.detailDialog = true;
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else {
                this.detailDialog = true;
            }
        },

        closeDetail() {
            this.detailItem = Object.assign({}, this.defaultDetailItem);
            this.detailDialog = false;
        },
        deleteItem() {
            return http.delete(this.TIMESHEET_URL + "/" + this.detailItem.code).then(res => {
                this.fetchData();
            })
        },

        // DATALIST
        initDates(val) {
        },

        // CREATE DATA 
        acceptTimesheet() {
            this.detailItem.isConfirmed = true;
            this.saveData()
        },
        cancelTimesheet() {
            this.detailItem.isConfirmed = false;
            this.saveData()
        },

        saveData() {
            let isEdit = !!this.detailItem.code;
            if (isEdit) {
                delete this.detailItem.enrollments;
                return http.put(this.TIMESHEET_URL + "/" + this.detailItem.code, this.detailItem)
                    .then(res => {
                        this.fetchData();
                        let eventObj = {
                            color: "success",
                            message: "Lưu dữ liệu thành công",
                            toast: true,
                        };
                        this.messageToast(eventObj);
                    })
                    .catch(err => {
                        console.log(err)
                    });
            }
            else {
                let form = {
                    employeeCode: this.detailItem.employeeCode,
                    workDate: moment(this.detailItem.workDateStr, "DDMMYYYY").format("YYYY-MM-DD"),
                    isConfirmed: this.detailItem.isConfirmed,
                    actualWorkTime: this.detailItem.actualWorkTime,
                    overtime: this.detailItem.overtime,
                    leaveTime: this.detailItem.leaveTime,
                    holidayOvertime: this.detailItem.holidayOvertime,
                    holidayActualTime: this.detailItem.holidayActualTime,
                    note: this.detailItem.note
                }
                return http.post(this.TIMESHEET_URL, form).then(res => {
                    this.fetchData();
                    let eventObj = {
                        color: "success",
                        message: "Lưu dữ liệu thành công",
                        toast: true,
                    };
                    this.messageToast(eventObj);
                });
            }
        },

        // ********* FETCH SECTION ************
        fetchData(search = false) {
            if (search)
                this.options.page = 1;
            const { page, itemsPerPage } = this.options;
            this.params = {
                ...this.params,
                sortBy: this.options.sortBy, //array
                sortDesc: this.options.sortDesc, //array
                page: this.options.page,
                pageSize: this.options.itemsPerPage,
            };

            return http.get('timesheets', {
                params: this.params
            }).then(res => {
                this.totalItem = res.data.totalItem;
                this.initDates();
                this.tableData = res.data.items;
                console.log(this.tableData);
                this.$nextTick(() => {
                    this.updateScrollState();
                });
            })
                .catch(err => {
                    console.log(err);
                })
        },
        fetchDepartment() {
            return http.get("departments?dropDown=1")
                .then(res => {
                    this.filter.FilterAttrs[0] = { text: "Phòng", items: res.data };
                })
                .catch(err => {
                    console.log(err)
                });
        },

        getTeam() {
            return http.get(`departments/team/${this.params.searchs[1]}`).then(r => {
                this.filter.FilterAttrs[2].items = r.data.data
                // this.filters.teamCode = null
            })
        },

        fetchPositionState() {
            return http.get("positionStates")
                .then(res => {
                    this.filter.FilterAttrs[1] = { text: "Chức danh", items: res.data };
                })
                .catch(err => {
                    console.log(err)
                });
        }

    },
    created() {
        this.fetchDepartment();
        this.fetchPositionState()
        // this.initDates();
        this.initDateRange();
        this.fetchData();
    },
    mounted() {
        this.$nextTick(() => {
            const container = this.$el.querySelector('.v-data-table__wrapper');
            if (container) {
                container.addEventListener('scroll', this.updateScrollState);
                window.addEventListener('resize', this.updateScrollState);
                this.updateScrollState();
            }
        });
    },
    beforeDestroy() {
        const container = this.$el.querySelector('.v-data-table__wrapper');
        if (container) {
            container.removeEventListener('scroll', this.updateScrollState);
        }
        window.removeEventListener('resize', this.updateScrollState);
    }
}
</script>

<style scoped>
.datatable-scroll-container {
    position: relative;
}

.scroll-edge-btn {
    position: absolute !important;
    top: 50%;
    transform: translateY(-50%) scale(0.9);
    z-index: 10;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease, transform 0.3s ease, background-color 0.3s ease !important;
    box-shadow: 0 4px 10px rgba(0,0,0,0.3) !important;
}

.datatable-scroll-container:hover .scroll-edge-btn {
    opacity: 0.8;
    pointer-events: auto;
}

.scroll-edge-btn:hover {
    opacity: 1 !important;
    transform: translateY(-50%) scale(1.1) !important;
}

.left-btn {
    left: 10px;
}

.right-btn {
    right: 10px;
}

@media screen and (min-width: 600px) {
    .left-btn {
        left: 235px; /* Sau 2 cột sticky (Mã NV + Tên NV) */
    }
}

::v-deep .v-data-table__wrapper {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
::v-deep .v-data-table__wrapper::-webkit-scrollbar {
    display: none;  /* Chrome, Safari and Opera */
}

tbody tr:hover {
    background-color: transparent !important;
}

@media screen and (min-width: 600px) {

    ::v-deep table>thead>tr>th:nth-child(1),
    ::v-deep table>tbody>tr>td:nth-child(1) {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 0;
        /* margin-left: -100px !important; */
        z-index: 3;
        background: white;
    }

    ::v-deep table>thead>tr>th:nth-child(2),
    ::v-deep table>tbody>tr>td:nth-child(2) {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 100px !important;
        z-index: 3;
        background: white;
    }

    /* ::v-deep table > thead > tr > th:nth-child(3),
        ::v-deep table > tbody > tr > td:nth-child(3){
            position: sticky !important; 
            position: -webkit-sticky !important; 
            left: 220px !important; 
            z-index: 3;
            background: white;
        } */

    /* ::v-deep table > thead > tr > th:nth-child(4),
        ::v-deep table > tbody > tr > td:nth-child(4){
            position: sticky !important; 
            position: -webkit-sticky !important; 
            left: 220px !important; 
            z-index: 3;
            background: white;
        } */
}

::v-deep table>thead>tr>th:nth-child(1) {
    z-index: 4;
}

::v-deep table>thead>tr>th:nth-child(2) {
    z-index: 4;
}

/* ::v-deep table > thead > tr > th:nth-child(3) {
        z-index: 4;
    }
    ::v-deep table > thead > tr > th:nth-child(4) {
        z-index: 4;
    } */
::v-deep table>tbody>tr>td {
    padding-left: 0px !important;
    padding-right: 0px !important;
    /* color: red; */
}

.small-cell {
    width: 20px !important;
    min-width: 0px !important;
}

.border-active {
    border-style: solid;
    border-width: 2px;
    border-radius: .5rem;
}

@media screen and (max-width: 600px) {
    ::v-deep table {
        zoom: 0.75;
    }
}
</style>